(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'BucketManage',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);

		// $('.delete-checked').click(function deletePressed(e) {
		// 	e.preventDefault();

		// 	Adzuki.CustomConfirm({
		// 		title  : 'Delete all?',
		// 		content: 'Are you sure you want to delete all checked buckets?',
		// 			confirm: function confirm() {
		// 				return true;
		// 			}
		// 	});
	});

	// form.success = function success(response)
	// {
	// 	var num_checked = 0,
	// 		current_amount,
	// 		new_amount;

	// 	$('.inline-checkbox').each(function checkDemBoxes() {
	// 		if ($(this).prop('checked') === true) {
	// 			num_checked++;
	// 		}
	// 	});

	// 	current_amount = $('.bucket-link a').attr('data-amount');
	// 	new_amount     = parseInt(current_amount) - num_checked;

	// 	if (new_amount <= 0) {
	// 		new_amount = 0;
	// 	}

	// 	$('.bucket-link a').attr('data-amount', new_amount);

	// 	return false;
	// };
}(jQuery, window.Adzuki || {}));